import { ValueOf } from 'next/dist/shared/lib/constants';

import { BrowserStorageManager } from '@/common/utils/browserStorage/BrowserStorageManager.abstract';

export enum SessionStorageKey {
  SEARCH_TRACKING_METADATA = 'searchTrackingData',
  PROMO_BAR = 'isPromoBarClosed',
}

export type SessionStorageData = {
  [SessionStorageKey.SEARCH_TRACKING_METADATA]: {
    searchQueryId: string | null;
    searchPosition: string | null;
    sort: string | null;
  };
  [SessionStorageKey.PROMO_BAR]: boolean;
};

export class SessionStorageManager<
  DataType extends ValueOf<SessionStorageData>,
> extends BrowserStorageManager<DataType> {
  constructor(key: SessionStorageKey) {
    super(key, globalThis.sessionStorage);
  }
}
